// const sendModel = async (url, model, fileObj) => {
const sendModel = async (url, model) => {

    const cloneModel = {...model}

    // if(typeof fileObj === 'object' && !Array.isArray(fileObj) && fileObj !== null && fileObj.success ) {
    //     cloneModel.filename = fileObj['filename'] + '.' + fileObj['extension']
    // }

    cloneModel.step = 3

    return await send(url, cloneModel)

}

const send = async (url, model) => {

    const params = new URLSearchParams();

    for(let key in model) {
        params.append(key, model[key]);
    }

    const options = {
        method: `POST`,
        body: params
    }

    let result = null

    await fetch(url, options)
        .then((data) => {
            return data.json();
        })
        .then((data) => {
            result = data
        })
        .catch((error) => {
            console.log(error)
        });

    return result

}

export {sendModel}